// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Card{border-radius:.375rem;margin:1rem}`, "",{"version":3,"sources":["webpack://./source/components/cards/Card.scss"],"names":[],"mappings":"AAEA,MACC,qBAAA,CACA,WAAA","sourcesContent":["@import \"/source/global.scss\";\n\n.Card {\n\tborder-radius: 0.375rem;\n\tmargin: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
